/** ******************************************************* {COPYRIGHT-TOP} ***
 * Licensed Materials - Property of IBM
 *
 * (C) Copyright IBM Corporation 2021, 2025
 *
 * All Rights Reserved.
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 ********************************************************** {COPYRIGHT-END} * */
import React, { useContext } from 'react';

const ApiContext = React.createContext({});

function ApiHandlerProvider({ children, api, handler, loading, error }) {
  // eslint-disable-next-line react/jsx-no-constructed-context-values
  return <ApiContext.Provider value={{ api, apiHandler: handler, loading, error }}>{children}</ApiContext.Provider>;
}

const useApi = () => useContext(ApiContext);

export default ApiHandlerProvider;
export { useApi, ApiContext };
